// extracted by mini-css-extract-plugin
export var allNePasManquer = "ne-pas-manquer-module--all-ne-pas-manquer--eef08";
export var editButtonTitle = "ne-pas-manquer-module--edit-button-title--c0e6c";
export var nePasManquerContainer = "ne-pas-manquer-module--ne-pas-manquer-container--828dc";
export var nePasManquerItem = "ne-pas-manquer-module--ne-pas-manquer-item--abe71";
export var nePasManquerItemDescription = "ne-pas-manquer-module--ne-pas-manquer-item-description--47ca7";
export var nePasManquerItemImg = "ne-pas-manquer-module--ne-pas-manquer-item-img--67acc";
export var nePasManquerListItem = "ne-pas-manquer-module--ne-pas-manquer-list-item--e6645";
export var nePasManquerResume = "ne-pas-manquer-module--ne-pas-manquer-resume--a5504";
export var nePasManquerTitle = "ne-pas-manquer-module--ne-pas-manquer-title--2214e";